const noop = () => {
    // no op function
};

export default noop;
